import { render, staticRenderFns } from "./SPopUp.vue?vue&type=template&id=f5fe5e84&scoped=true"
import script from "./sPopUp.ts?vue&type=script&lang=ts&external"
export * from "./sPopUp.ts?vue&type=script&lang=ts&external"
import style0 from "./SPopUp.vue?vue&type=style&index=0&id=f5fe5e84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fe5e84",
  null
  
)

export default component.exports